import { BP42Action } from '@r1-frontend/bp42/constants/actions';
import { BP42IncomingData } from '@r1-frontend/bp42/reducer/initialState';

import { IAction } from '@r1-frontend/shared/types/Redux';

const initialization = (incomingData: Partial<BP42IncomingData>): IAction<BP42Action.Initialization, Partial<BP42IncomingData>> => ({
    type: BP42Action.Initialization,
    payload: {
        ...incomingData,
    },
});

export default initialization;
